<template>
  <div class="container-fluid h-100">
    <b-row class="h-100 justify-content-center align-items-center pl-2">
      <b-col class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10">
        <b-row>
          <b-col class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-7">
            <b-img src="../assets/img/smartfarm-firstpage-logo-2022.png" fluid></b-img>
          </b-col>
        </b-row>
        <b-row class="p-2">
          <b-col class="col-12">
            <b-button class="ml-1 ml-lg-4 mb-5 rounded-pill btn-login px-5 p-2 font-weight-bold" v-b-modal.modal-login>เข้าสู่ระบบ</b-button>
            <Login />
            <Register />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Login from '@/components/Login.vue'
import Register from '@/components/Register.vue'

export default {
  name: 'login',
  components: {
    Login,
    Register
  },
  data() {
    return {
    }
  },
  mounted() {
    this.loggedOut()
  },
  methods: {
    loggedOut() {
      this.$store.dispatch('destroyToken')
    }
  }
}
</script>

<style>
  /* @import '../assets/css/Page.css';
  @import '../assets/css/Login.css';
  @import '../assets/css/Font.css'; */
  .btn-login {
    border: 3px #04920b solid;
    background-color: #ffffff;
    color: #707070;
  }
  .btn-login:hover {
    border: 3px #ffffff solid;
    background-color: #04920b;
    color: #ffffff;
  }

  /* Extra Small Devices, Phones4 */ 
  @media only screen and (min-width : 320px) {
    html, body {
      height: 100%;
      background-image: url("../assets/img/smartfarm-firstpage-mobile-P-2022.png");
      background-attachment: fixed;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
    }
  }

  /* Small devices (landscape phones, 576px and up)*/
  @media only screen and (min-width: 576px) {
      /* background-image: url("../assets/img/smartfarm-firstpage-mobile-L.png"); */
    html, body {
      height: 100%;
      background-image: url("../assets/img/smartfarm-firstpage-desktop-2022.png");
      background-attachment: fixed;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
    }
  }

  /* Medium devices (tablets, 768px and up)*/
  @media only screen and (min-width: 768px) {
    html, body {
      height: 100%;
      background-image: url("../assets/img/smartfarm-firstpage-ipad-P-2022.png");
      background-attachment: fixed;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
    }
  }

  /* Large devices (desktops, 992px and up)*/
  @media only screen and (min-width: 992px) {
    html, body {
      height: 100%;
      background-image: url("../assets/img/smartfarm-firstpage-ipad-L-2022.png");
      background-attachment: fixed;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
    }
  }

  /* Extra Large devices (desktops, 1366px and up)*/
  @media only screen and (min-width: 1366px) {
    html, body {
      height: 100%;
      background-image: url("../assets/img/smartfarm-firstpage-desktop-2022.png");
      background-attachment: fixed;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
    }
  }
</style>
